export default __webpack_public_path__ + "static/media/baby-25.cebe8034.svg";